import { Action, getModule, Module, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { GeneralFeedback } from '@/store/models';
import { submitGeneralFeedbackData } from '@/store/api';

@Module({
  namespaced: true,
  name: 'generalFeedback',
  store,
  dynamic: true,
})
class GeneralFeedbackModule extends VuexModule {
  @Action
  public async submitGeneralFeedback(generalFeedbackData: GeneralFeedback) {
    console.log('generalFeedbackData to send', generalFeedbackData);
    return await submitGeneralFeedbackData(generalFeedbackData);
  }
}

export default getModule(GeneralFeedbackModule);
